import { render, staticRenderFns } from "./sysholiday.vue?vue&type=template&id=b6f58bf8&scoped=true&"
import script from "./sysholiday.vue?vue&type=script&lang=js&"
export * from "./sysholiday.vue?vue&type=script&lang=js&"
import style0 from "./sysholiday.vue?vue&type=style&index=0&id=b6f58bf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f58bf8",
  null
  
)

export default component.exports